const e = "ids-table-v5150", t = "ids-table--compact-v5150", o = "ids-table--row-group-header-v5150", r = "ids-table--row-group-column-headers-v5150", s = "ids-table--divider-v5150", d = "ids-table--hover-v5150", i = "ids-table--wrapper-v5150", c = "ids-table--sort-button-v5150", l = "ids-table--sort-button-no-wrap-v5150", a = "ids-table--sort-icon-v5150", n = "ids-table--hidden-header-v5150", v = "ids-table--activator-v5150", b = {
  table: e,
  compact: t,
  rowGroupHeader: o,
  rowGroupColumnHeaders: r,
  divider: s,
  "cell--number": "ids-table--cell--number-v5150",
  "cell--center": "ids-table--cell--center-v5150",
  "cell--left": "ids-table--cell--left-v5150",
  "cell--currency": "ids-table--cell--currency-v5150",
  "cell--right": "ids-table--cell--right-v5150",
  "ids-input--formControl": "ids-input--form-control-v5150",
  "ids-field": "ids-field-v5150",
  "ids-checkbox": "ids-checkbox-v5150",
  "ids-checkbox--label": "ids-checkbox--label-v5150",
  "ids-checkbox--input": "ids-checkbox--input-v5150",
  "ids-checkbox--mark": "ids-checkbox--mark-v5150",
  "ids-label--hidden": "ids-label--hidden-v5150",
  "ids-field--input-container": "ids-field--input-container-v5150",
  "iress-view-mode-compact": "ids-table--iress-view-mode-compact-v5150",
  hover: d,
  wrapper: i,
  sortButton: c,
  sortButtonNoWrap: l,
  sortIcon: a,
  hiddenHeader: n,
  activator: v,
  "pseudo-hover": "ids-table--pseudo-hover-v5150"
};
export {
  b as s
};
